import React from 'react'
import { useTranslation } from 'react-i18next'

import { useConfigContext } from '../../../features/ui-config'
import { getConfigTranslation } from '../../../utils/helper/getConfigTranslation'
import { CheckFieldOptions } from '../getMissingFieldsFromData'

type Props = {
  missingFields: CheckFieldOptions[]
  configKey: string
}

export const MissingFieldsList: React.FC<Props> = ({
  missingFields,
  configKey,
}) => {
  const { uiConfig: config } = useConfigContext()
  const { t } = useTranslation()

  return (
    <ul className="my-1 pl-3">
      {missingFields.map((missingField, index) => {
        const translationPath = `${configKey}.${missingField.requiredFieldPath}.label`
        const translation = getNestedProperty(config, translationPath)

        return (
          <li key={index}>
            {/* If the missing field is an item show the position so the user can find it faster */}
            {missingField.orderPosition && (
              <>
                {t('common.tooltips.posNo')} {missingField.orderPosition}:{' '}
              </>
            )}

            {/* Label of the missing field */}
            {getConfigTranslation(translation)}
          </li>
        )
      })}
    </ul>
  )
}

function getNestedProperty(obj: Record<string, any>, path: string) {
  return path.split('.').reduce((acc: any, part: any) => acc && acc[part], obj)
}
